<div class="flexDatesToggle__cont">
  <p>{{ 'SEARCH_MODULE.DATE_FLEX' | transloco }}</p>
  <app-ds-toggle
    [isActive]="isActive"
    (toggleOnChange)="onChange($event)">
  </app-ds-toggle>
</div>